import { match } from "ts-pattern";

export const ALLOWED_TLDS = [
  "maybern.com",
  "maybern.test",
  "maybern.internal",
  "maybern.staging",
];

export const getAuthRootUrl = (location: URL, enableSubdomains: boolean) =>
  match(location.hostname)
    .when(
      (hostname) =>
        !hostname ||
        !enableSubdomains ||
        ("global" in window && "authRootUrl" in global && global.authRootUrl),
      () => new URL("http://localhost:3000"),
    )
    .when(
      (hostname) =>
        hostname.endsWith(".maybern.test") || hostname === "localhost",
      () => new URL(`${location.protocol}//app.maybern.test:${location.port}`),
    )
    .when(
      (hostname) => ALLOWED_TLDS.some((tld) => hostname.endsWith(`.${tld}`)),
      (hostname) => {
        const matchedTld = ALLOWED_TLDS.find((tld) =>
          hostname.endsWith(`.${tld}`),
        );
        return new URL(`https://app.${matchedTld}`);
      },
    )
    .otherwise((hostname) => {
      throw new Error(`Unknown hostname for subdomains: ${hostname}`);
    });
